<!-- 获取车场数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S"
            },
            responseCode: {
                    "data": {
                        "payData": {
                            "isAlipay": 1,
                            "isAutoPay": 1,
                            "isCenduty": 1,
                            "isEtcPay": 0,
                            "isInvoice": 1,
                            "isMonthlyTicket": 1,
                            "isTraderCoupon": 1,
                            "isUseScore": 1,
                            "isWechatPay": 1
                        },
                        "slotsNumber": 380,
                        "yesterdayValue": 0
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车场数据",
                t_url: this.commonUrls.test+"parkMessage",
                p_url: this.commonUrls.prod+"parkMessage",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'slotsNumber', info2: '是', info3: 'Integer', info4: '车位数' },
                        { info1: 'yesterdayValue', info2: '是', info3: 'Decimal', info4: '昨日收费' },
                        { info1: 'payData', info2: '是', info3: 'JSONObject', info4: '车场支付信息' },
                        ]
                },{
                    titleName: 'payData',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'isWechatPay', info2: '是', info3: 'Integer', info4: '是否开通微信支付，0未开通 1已开通' },
                        { info1: 'isAlipay', info2: '是', info3: 'Integer', info4: '是否开通支付宝支付，0未开通 1已开通' },
                        { info1: 'isEtcPay', info2: '是', info3: 'Integer', info4: '是否开通ETC支付，0未开通 1已开通' },
                        { info1: 'isMonthlyTicket', info2: '是', info3: 'Integer', info4: '是否开通电子月票，0未开通 1已开通' },
                        { info1: 'isInvoice', info2: '是', info3: 'Integer', info4: '是否开通电子发票，0未开通 1已开通' },
                        { info1: 'isAutoPay', info2: '是', info3: 'Integer', info4: '是否开通无感支付，0未开通 1已开通' },
                        { info1: 'isCenduty', info2: '是', info3: 'Integer', info4: '是否开通中央值守，0未开通 1已开通' },
                        { info1: 'isTraderCoupon', info2: '是', info3: 'Integer', info4: '是否开通电子优惠券，0未开通 1已开通' },
                        { info1: 'isUseScore', info2: '是', info3: 'Integer', info4: '是否开通商场积分，0未开通 1已开通' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/parkMessage.vue